import { jsx as r } from "react/jsx-runtime";
import { createContext as v, forwardRef as b } from "react";
import { useStyleConfig as N, HStack as P } from "@chakra-ui/react";
import { useRadioGroup as S } from "@chakra-ui/radio";
import { FormControl as H } from "../FormControl/FormControl.mjs";
const O = v(null), T = b((d, $) => {
  const {
    children: i,
    error: n,
    formHelperText: c,
    hideOptionalLabel: p = !1,
    isAttached: f = !1,
    isRequired: u,
    label: m,
    name: e,
    id: s = e,
    onChange: o,
    value: t,
    variant: h = "radio",
    controlStyleProps: C,
    controlClassName: R,
    "data-testid": l,
    ...g
  } = d, x = N("RadioGroup"), y = (a) => {
    o(a === "true" ? !0 : a === "false" ? !1 : a);
  }, { getRadioProps: G } = S({
    name: e,
    onChange: y,
    // Handle true / false boolean
    value: typeof t == "boolean" ? `${t}` : t
  });
  return /* @__PURE__ */ r(
    H,
    {
      error: n,
      hideOptionalLabel: p,
      isRequired: u,
      label: m,
      name: e,
      id: s,
      formHelperText: c,
      "data-testid": l && `${l}-control`,
      className: R,
      ...C,
      ...g,
      children: /* @__PURE__ */ r(O.Provider, { value: { getRadioProps: G, variant: h, id: s }, children: f ? /* @__PURE__ */ r(
        P,
        {
          spacing: 0,
          "data-attached": !0,
          "data-orientation": "horizontal",
          sx: x,
          ...n && { "data-invalid": "true" },
          children: i
        }
      ) : i })
    }
  );
});
T.displayName = "RadioGroup";
export {
  T as RadioGroup,
  O as RadioGroupContext
};
